import styled from "styled-components";
import { sharedGap } from "../../styles";

export const StyledFixtureAdvancedSection = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: ${sharedGap};

  /*
  4n+1 means every 4th element starting from 1st
  4n+2 means every 4th element starting from 2nd
  */
  & > :nth-child(4n+1),
  & > :nth-child(4n+2) {
    grid-column: span 2;
  }

  /*
  4n+3 means every 4th element starting from 3rd
  4n+4 means every 4th element starting from 4th
  */
  & > :nth-child(4n+3),
  & > :nth-child(4n+4) {
    grid-column: span 1;
  }

  /* n + 17 means all elements starting from 17th */
  & > :nth-child(n + 17) {
    grid-column: span 2;
  }
`;
StyledFixtureAdvancedSection.displayName = "StyledFixtureAdvancedSection";
